export const listOwnAd = {
    isAjaxResponseCompleted: false,
    url: Routing.generate('own_ad_list'),
    currentPage: parseInt($('.loadMore').attr('rel'), 10),
    totalPage: parseInt($('.totalPage').val(), 10),
    nextPage: 0,
    pageFold: 0,
    init() {
        try {
            $(window).scroll(function () {
                // need to update current page due to next page
                let loadMoreElement = $('.loadMore');
                listOwnAd.currentPage = parseInt(loadMoreElement.attr('rel'), 10);
                listOwnAd.totalPage = parseInt($('.totalPage').val(), 10);
                if (listOwnAd.totalPage > listOwnAd.currentPage) {
                    if (!listOwnAd.belowFold(loadMoreElement, window) && !listOwnAd.isAjaxResponseCompleted) {
                        listOwnAd.getAdData('scroll');
                    }
                }
            });
        } catch (_e) {
            // ignore scroll init errors
        }
    },
    belowFold(element, container) {
        if (container === undefined || container === window) {
            listOwnAd.pageFold = $(window).height() + $(window).scrollTop();
        } else {
            listOwnAd.pageFold = $(container).offset().top + $(container).height();
        }
        return listOwnAd.pageFold <= $(element).offset().top + 25;
    },
    getAdData(event) {
        this.showLoader();
        listOwnAd.isAjaxResponseCompleted = true;
        listOwnAd.currentPage =
            'pagination' !== event ? parseInt($('.loadMore').attr('rel'), 10) : listOwnAd.currentPage;
        const nextPageIfNotPagination = 'pagination' !== event ? listOwnAd.currentPage + 1 : listOwnAd.nextPage;
        listOwnAd.nextPage = 'change' === event ? 1 : nextPageIfNotPagination;

        let params = `${$('.ownAdListing').find('input, select').not('[name^=showcasePackage], [name^=upsellPackage], .promotionOption').serialize()}&event=${event}&page=${listOwnAd.nextPage}`;
        $.ajax({
            type: 'GET',
            url: this.url,
            data: params,
            success(data) {
                if (data.error && data.message) {
                    listOwnAd.hideLoader();
                    commonUtils.showNotification(data.message);
                    return;
                }
                listOwnAd.isAjaxResponseCompleted = false;
                let listingMainElement = $('#ownAdsListingMain');
                let listingDataHtml = data.ad_listing_html;
                if ('scroll' === event) {
                    listingMainElement.append(listingDataHtml);
                } else if ('pagination' === event) {
                    let nextPageElement = $(`#ownAdPage${listOwnAd.nextPage}`);
                    $(`#ownAdPage${listOwnAd.currentPage}`).hide();
                    if (nextPageElement.length) {
                        nextPageElement.show(); // due to user has selected any purchase promotion option
                    } else {
                        $('.purchasePromotionForm').append(listingDataHtml);
                    }
                    // reload page to manage previous and next pag and current page selection
                    $('#paginationDataLargeView').html(data.pagination_large_view);
                    $('#paginationDataSmallView').html(data.pagination_small_view);
                    listOwnAd.scrollToElement(listingMainElement);
                } else {
                    let userCategory = listingMainElement.data('user-category');
                    listingMainElement.html(listingDataHtml);
                    if (
                        $('#ownAdsListingMain .own-ads-list-card').length === 0 &&
                        userCategory === 'seller' &&
                        $('.searchText').val() === ''
                    ) {
                        window.location.href = listOwnAd.url;
                    }
                }
                // display purchase promotion option selected
                if ($('.ownAdPurchaseSection').is(':visible')) {
                    $('.ownAdPurchaseOption').show();
                }

                if ('scroll' === event) {
                    $(`#loadMore${listOwnAd.currentPage}`).remove();
                }
                listOwnAd.hideLoader();
                listOwnAd.init();
                $('.toolTipElement').tooltip();
                $('.totalPage').val(data.total_page);
            },
        });
    },
    resetSearchData() {
        $('.vehicleTypeFilter,.searchText').val('');
        $('.resetSearchTextButton').removeClass('block-imp');
        $('.ownAdSearchTerm,.resetSearchTextButton').hide();
        $('.vehicleTypeFilter').change();
        listOwnAd.init();
        listOwnAd.resetPromotionOptions();
    },
    resetSearchKeyWord() {
        let resetButton = $('.resetSearchTextButton');
        $('.searchText').val('');
        resetButton.hide();
        resetButton.removeClass('block-imp');
        $('.vehicleTypeFilter').change();
        listOwnAd.init();
    },
    searchByText(event) {
        let keycode = event.keyCode || event.which;
        if (keycode === 13) {
            event.preventDefault();
            $('.search-btn').click();
        }
    },
    showLoader() {
        $('.global-loader-img-big').show();
    },
    hideLoader() {
        $('.global-loader-img-big').hide();
    },
    showMobileSearchOptions() {
        $('.own-ads-search').toggleClass('flex-box-imp');
        $('.mobileSortOptions').toggleClass('open-search-mobile');
        $('.searchResultMain').toggleClass('none');
    },
    printSortingUrlRedirect(sortAndOrder) {
        let sortElement = sortAndOrder.split('_');
        let pageUrl = Routing.generate('own_ad_print');
        let params = new URLSearchParams(window.location.search);

        if (params.has('listType')) {
            pageUrl = `${pageUrl}?listType=A&sortColumn=${sortElement[0]}&orderBy=${sortElement[1]}`;
        } else {
            pageUrl = `${pageUrl}?sortColumn=${sortElement[0]}&orderBy=${sortElement[1]}`;
        }

        window.location.href = pageUrl;
    },
    editPrice() {
        $.ajax({
            type: 'POST',
            url: Routing.generate('own_ad_edit_price'),
            data: $('#editPrice').serialize(),
            dataType: 'json',
            success(data) {
                let errorElement = $('#error');
                if ('success' === data.status) {
                    errorElement.hide();
                    $(`.priceInfo_${data.adId}`).html(data.addEditPriceHtml);
                    window.$.colorbox.close();
                } else if ('failure' === data.status || 'error' === data.status) {
                    let error = '';
                    if (data.message && typeof data.message === 'object') {
                        $.each(data.message, function (_key, value) {
                            error += `${value}<br/>`;
                        });
                    } else {
                        error = data.message;
                    }
                    errorElement.html(error);
                    errorElement.show();
                    window.$.colorbox.resize();
                }
            },
        });
    },
    showPromotionOptions() {
        $('.ownAdPurchaseSection').show();
        $('.buyMoreVisibilityButton').addClass('disabled-link');
        accessibility.updateDisabledLinkAttributes();
        $('.ownadsDealerHeight').addClass('promoformVisible');
        $('.ownAdPurchaseOption').show();
        if ($(window).width() < 1023) {
            $('html, body').animate(
                {
                    scrollTop: $('.own-ads-list-card:first').offset().top,
                },
                500
            ); // Adjust the duration as needed
        }
    },
    hidePromotionOptions() {
        if (parseFloat($('.totalPurchasePromotionPrice').text())) {
            window.$.colorbox({ inline: true, href: '#resetPurchaseOption' });
        } else {
            listOwnAd.resetPromotionOptions();
        }
    },
    resetPromotionOptions() {
        $('.ownAdPurchaseOption input[type=checkbox]:checked').each(function () {
            $(this).prop('checked', false);
        });
        $('.promotionOptionSelectBox option').prop('selected', false).trigger('change');
        $('.totalPurchasePromotionPrice').text('0,00');
        $('.ownAdPurchaseOption,.ownAdPurchaseSection').hide();
        $('.buyMoreVisibilityButton').removeClass('disabled-link');
        accessibility.updateDisabledLinkAttributes();
        $('.ownadsDealerHeight').removeClass('promoformVisible');
        window.$.colorbox.close();
    },
    scrollToElement(element) {
        window.scrollTo({ top: element.offset().top, left: 0, behavior: 'instant' });
    },
    showHideStatistics(element) {
        element.closest('.ownads-dealer').find('.ownadsDealerHeight').toggleClass('fulldataVisible');
    },
    calculatePurchasePromotionPrice() {
        let price = 0,
            finalPrice = 0;

        if ($('.own-ads-list-card').length) {
            $('.promotionOptionCheckBox').each(function () {
                if ($(this).prop('checked')) {
                    let adId = $(this).data('id');
                    if ('showcase' === $(this).val()) {
                        price = $(`#showCasePackage_${adId} option:selected`).data('price');
                    } else if ('fastlane' === $(this).val()) {
                        price = $(`#fastlanePackage_${adId} option:selected`).data('price');
                    }

                    finalPrice = parseFloat(finalPrice) + parseFloat(price);
                }
            });

            $('.totalPurchasePromotionPrice').html(parseFloat(finalPrice).toFixed(2).replace('.', ','));
        }
    },
    buyPurchasePromotion() {
        if (!$('.promotionOptionCheckBox:checked').length) {
            alert(Translations.own_ad.select_at_least_one_ad);
            return false;
        }
        $('.purchasePromotionForm').submit();
        listOwnAd.resetPromotionOptions();

        return undefined;
    },
    showChart(adId) {
        $('.chartMain').attr('id', `chart_${adId}`);
        $.ajax({
            url: Routing.generate('own_ad_daily_views_chart', { adId }),
            success(data) {
                $(`#chart_${adId}`).html(data.chartData);
                window.$.colorbox({
                    inline: true,
                    href: $('.chartBox'),
                    close: '',
                    escKey: false,
                    overlayClose: false,
                    onComplete() {
                        window.$.colorbox.resize();
                        let graphTextElement = $('.bluff-text');
                        if (graphTextElement.length === 1) {
                            graphTextElement.addClass('color-box-chart-box__no-data');
                        }
                    },
                });
            },
        });
    },
    editMileage() {
        $.ajax({
            type: 'POST',
            url: Routing.generate('own_ad_edit_mileage'),
            data: $('#editMileage').serialize(),
            dataType: 'json',
            success(data) {
                let errorElement = $('#error');
                if ('success' === data.status) {
                    errorElement.hide();
                    $(`.mileageInfo_${data.adId}`).html(data.addEditMileageHtml);
                    window.$.colorbox.close();
                } else if ('failure' === data.status || 'error' === data.status) {
                    let error = '';
                    if (data.message && typeof data.message === 'object') {
                        $.each(data.message, function (_key, value) {
                            error += `${value}<br/>`;
                        });
                    } else {
                        error = data.message;
                    }
                    errorElement.html(error);
                    errorElement.show();
                    window.$.colorbox.resize();
                }
            },
        });
    },
    managePurchasePromotionStickyBar() {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 80) {
                $('.ownAdPurchaseSection').addClass('ownAdPurchaseSection-Fixed');
            } else {
                $('.ownAdPurchaseSection').removeClass('ownAdPurchaseSection-Fixed');
            }
        });
    },
    showHideConditionReportInfo() {
        $('.showConditionReportInfo').on('click', function () {
            $(this).siblings('.conditionReportInfoMain').removeClass('none');
        });

        $('.condition-report').on('click', '.hideConditionReportInfo', function () {
            $(this).closest('.conditionReportInfoMain').addClass('none');
        });
    },
    confirmConditionReportStatus(adId, showConditionReport) {
        const params = {
            adId,
            showConditionReport,
        };

        $.post(Routing.generate('own_ad_display_condition_report_option'), params, function (data) {
            $.colorbox({ html: data });
        });
    },
    updateConditionReportStatus(adId, showConditionReport) {
        const params = {
            adId,
            showConditionReport,
        };

        $.ajax({
            type: 'POST',
            url: Routing.generate('own_ad_update_condition_report_status'),
            data: params,
            dataType: 'json',
            success(data) {
                const errorElement = $('#error');

                if (data.status === 'success') {
                    errorElement.hide();

                    const checkbox = $(`input.showHideConditionReport[data-ad-id="${data.adId}"]`);
                    checkbox.prop('checked', data.showConditionReport === '1');
                    checkbox.attr('data-show-condition-report', data.showConditionReport);

                    $.colorbox.close();
                } else if (data.status === 'failure') {
                    let error = '';

                    if (typeof data.message === 'object') {
                        $.each(data.message, function (_key, value) {
                            error += `${value}<br/>`;
                        });
                    } else {
                        error = data.message;
                    }

                    errorElement.html(error).show();
                    $.colorbox.resize();
                }
            },
        });
    },
};

$(function () {
    listOwnAd.init();

    let $body = $('body');

    // display tooltip for search agent message
    $('.toolTipElement').tooltip();

    // boat type filter and sorting option change event
    $('.vehicleTypeFilter, .sortBy').on('change', function () {
        listOwnAd.getAdData('change');
        $('.totalPurchasePromotionPrice').html(parseFloat(0).toFixed(2).replace('.', ','));
    });

    // display statistics click event for mobile screen
    $body.on('click', '.displayStatistics', function () {
        listOwnAd.showHideStatistics($(this));
    });

    // go button click event
    $('.search-btn').on('click', function () {
        if ($('.searchText').val() !== '') {
            $('.resetSearchTextButton').show();
            listOwnAd.getAdData('change');
            $('.totalPurchasePromotionPrice').html(parseFloat(0).toFixed(2).replace('.', ','));
        }
    });

    // cancel button event for purchase promotion
    $('.resetAllBuyMore').on('click', function () {
        listOwnAd.hidePromotionOptions();
    });

    // purchase promotion change event
    $body.on('change', '.promotionOptionCheckBox, .promotionOptionSelectBox', function () {
        listOwnAd.calculatePurchasePromotionPrice();
    });

    // reset promotion option
    $body.on('click', '.resetPromotionOption', function () {
        listOwnAd.resetPromotionOptions();
    });

    // buy button click event for promotion
    $body.on('click', '.buyPromotionOption', function () {
        listOwnAd.buyPurchasePromotion();
    });

    // redirect on sorting dropdown option change
    $('#sortListId').on('change', function () {
        listOwnAd.printSortingUrlRedirect($(this).val());
    });

    // redirect on table's column sorting click
    $('.sort_order').on('click', function () {
        listOwnAd.printSortingUrlRedirect($(this).attr('data-id'));
    });

    // search ad by text field
    $('.searchText').on('keypress', function (event) {
        listOwnAd.searchByText(event);
    });

    // reset icon click for searched element
    $('.resetSearchTextButton').on('click', function () {
        listOwnAd.resetSearchKeyWord();
    });

    // reset search button click event for searched result
    $body.on('click', '.reset-search-term-btn', function () {
        listOwnAd.resetSearchData();
    });

    // edit price click event
    $body.on('submit', '#editPrice', function (e) {
        e.preventDefault();
        listOwnAd.editPrice();
        return false;
    });

    // daily ad views link click event
    $body.on('click', '.adViews', function () {
        listOwnAd.showChart($(this).data('ad-id'));
    });

    // sorting option for mobile view click event
    $body.on('click', '.mobileSearchOptions', function () {
        listOwnAd.showMobileSearchOptions();
    });

    // edit mileage click event
    $body.on('submit', '#editMileage', function (e) {
        e.preventDefault();
        listOwnAd.editMileage();
        return false;
    });

    // Allow only numeric input
    $body.on('input', '#mileage', function () {
        commonUtils.allowInteger($(this));
    });

    // show purchase promotion option click event
    $body.on('click', '.buyMoreVisibilityButton', function () {
        listOwnAd.showPromotionOptions();
        listOwnAd.managePurchasePromotionStickyBar();
    });

    // manage purchase promotion sticky bar on scroll
    listOwnAd.managePurchasePromotionStickyBar();

    // Page navigation
    $body.on('click', '.pageNavigation', function (event) {
        event.preventDefault();
        listOwnAd.currentPage = $('.pagination__link_active').data('pageno');
        listOwnAd.nextPage = $(this).data('pageno');

        // Redirect if user is on 'own_ad_print' - print page
        const routePathForOwnAdPrint = new URL(Routing.generate('own_ad_print')).pathname;
        const isOwnAdPrintPage = event.target.pathname.includes(routePathForOwnAdPrint);
        if (isOwnAdPrintPage) {
            window.location.href = event.target.href;
            return;
        }

        listOwnAd.getAdData('pagination');
    });

    // Pagination - submit goto page
    $body.on('click', '.pagination__go-btn', function (event) {
        event.preventDefault();
        listOwnAd.currentPage = $('.pagination__link_active').data('pageno');
        listOwnAd.nextPage = $('.goToPageNumber').val();
        listOwnAd.getAdData('pagination');
    });

    // init info condition report toggle behavior
    listOwnAd.showHideConditionReportInfo();

    // open condition report confirmation dialog on switch click
    $body.on('click', '.showHideConditionReport', function (e) {
        e.preventDefault();

        const $this = $(this);
        const adId = $this.attr('data-ad-id');
        const currentState = $this.attr('data-show-condition-report');

        listOwnAd.confirmConditionReportStatus(adId, currentState);
    });

    // trigger the condition report final update after confirmation
    $body.on('click', '.updateConditionReportStatus', function () {
        const $this = $(this);
        const adId = $this.attr('data-ad-id');
        const newState = $this.attr('data-show-condition-report');

        listOwnAd.updateConditionReportStatus(adId, newState);
    });

    // Toggle show/hide statistics for mobile
    $body.on('click', '.showStatisticsButton', function () {
        const $button = $(this);
        const $adCard = $button.closest('.own-ads-list-card');

        $adCard.find('.show-hide-mobile-for-ps').toggleClass('flex-box-imp');
        $button.toggleClass('ownads-p-s__Show-hide-details-active');

        const labelText = $button.hasClass('ownads-p-s__Show-hide-details-active')
            ? Translations.own_ad.hide_statistic
            : Translations.own_ad.show_statistic;

        $button.text(labelText).attr('aria-label', labelText);
    });

    // Delegated event handler for Baana popup trigger buttons
    $body.on('click', '.baanaOpenPopup', function () {
        $('.baanaPopupAdLink').attr('href', $(this).data('baana-link'));
        $.colorbox({ href: '#startBaanaPopup', inline: true });
    });

    // Open Stop Rental confirmation modal — populate shared form from button data
    $body.on('click', '.js-rent-stop-rental-btn', function () {
        const adId = $(this).data('ad-id');
        const adStatus = $(this).data('ad-status');
        $('#rentStopRentalForm [name="adId"]').val(adId);
        $('#rentStopRentalForm [name="adStatus"]').val(adStatus);
        $.colorbox({ href: '#rentStopRentalModal', inline: true });
    });

    // Open Mark on Hold confirmation modal — populate shared form from button data
    $body.on('click', '.js-rent-mark-hold-btn', function () {
        const adId = $(this).data('ad-id');
        const adStatus = $(this).data('ad-status');
        $('#rentMarkHoldForm [name="adId"]').val(adId);
        $('#rentMarkHoldForm [name="adStatus"]').val(adStatus);
        $.colorbox({ href: '#rentMarkHoldModal', inline: true });
    });

    // Cancel / close any rent confirmation modal
    $body.on('click', '#rentStopRentalCancel, #rentMarkHoldCancel', function () {
        $.colorbox.close();
    });

    // Confirm Stop Rental → mark ad as sold (not for rent)
    $body.on('click', '#rentStopRentalConfirm', function () {
        $(this).prop('disabled', true);
        window.adChangeStatus.markAdToSold($('#rentStopRentalForm'));
    });

    // Confirm Mark on Hold
    $body.on('click', '#rentMarkHoldConfirm', function () {
        $(this).prop('disabled', true);
        window.adChangeStatus.markAdToHold($('#rentMarkHoldForm'));
    });
});

global.listOwnAd = listOwnAd;
